module.exports = __webpack_public_path__ + "media/blogs/hero_image-08410f39.png";